import { render } from "./QuestVictory04.vue?vue&type=template&id=b4c9fa48"
import script from "./QuestVictory04.vue?vue&type=script&lang=js"
export * from "./QuestVictory04.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/questVictories/QuestVictory04.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b4c9fa48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b4c9fa48', __exports__)) {
    api.reload('b4c9fa48', __exports__)
  }
  
  module.hot.accept("./QuestVictory04.vue?vue&type=template&id=b4c9fa48", () => {
    api.rerender('b4c9fa48', render)
  })

}


export default __exports__